import axios from 'axios'
import { HOTELSEARCH_URL } from '../constants'

export const getHotelSearchByName = async (data) => {
    try {
        const response = await axios.get(`${HOTELSEARCH_URL}?HotelName=${data}`)
        const hotelData = await response.data
        return hotelData
    } catch(err) {
        console.log("Hotel Not Found", err)
        throw err
    }
}
